<button class="search" (click)="emit()"></button>
<addiction-input
    [placeholder]="placeholder | translate"
    [formControl]="formControl"
    (keydown.enter)="emit()"
></addiction-input>
<button *ngIf="formControl.value" class="reset" (click)="reset()"></button>
